const env = process.env.APP_ENV || 'dev';
console.log('start server with env : ', env);

const config = require(`./config.${env}`);

export default config;



// WEBPACK FOOTER //
// ./src/index.js